import React from "react";
import { t } from "../../../../../utils/i18n";

const Terms = ({ offerTerms }) => (
  <div>
    <div className="createtrade-terms" title={t("p2p.create_trade.terms_tip")}>
      <h4>
        <i className="material-icons">assignment</i>
        <span>{t("p2p.create_trade.terms")}</span>
      </h4>
      <ul>
        <li>{offerTerms}</li>
      </ul>
    </div>
  </div>
);

export default Terms;
